// @flow
import { DestinosActionTypes } from './constants';

type DestinosAction = { type: string, payload: {} | string };

// common success
export const destinosApiResponseSuccess = (actionType: string, data: any): DestinosAction => ({
    type: DestinosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const destinosApiResponseError = (actionType: string, error: string): DestinosAction => ({
    type: DestinosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getDestino = (id: string): DestinosAction => ({
    type: DestinosActionTypes.GET_DESTINO,
    payload: { id },
});

export const addDestino = (destino:any):DestinosAction=>({
    type:DestinosActionTypes.ADD_DESTINO,
    payload:destino
})
export const updateDestino = (destino:any):DestinosAction=>({
    type:DestinosActionTypes.UPDATE_DESTINO,
    payload:destino
})
export const deleteDestino = (id:string):DestinosAction=>({
    type:DestinosActionTypes.DELETE_DESTINO,
    payload:{id}
})

export const listDestinos = (params:any): DestinosAction => ({
    type: DestinosActionTypes.LIST_DESTINOS,
    payload: params,
});

export const setFiltersDestinos = (params:any): DestinosAction => ({
    type: DestinosActionTypes.SET_FILTER,
    payload: params,
})

export const resetDestinos = (): DestinosAction => ({
    type: DestinosActionTypes.RESET,
    payload: {},
});

